<template>
 <div id="homePage" class="wrapper">

    <!-- top-bar start -->
    <!-- top-bar end -->

    <!-- content start -->
    <div class="content">

        <!-- jubao-section01 start -->
        <div class="jubao-section01">
            <div class="jubao-section01-con">
                <ul id="mindscape">
                    <li>
                        <span class="clouding"><img src="~assets/img/jubao/clouding.png" class="imgsize" alt=""></span>
                    </li>
                    <li>
                        <span class="jubao-title"><img src="~assets/img/jubao/jubao_title.png" class="imgsize" alt="聚宝计划"></span>
                    </li>
                    <li>
                        <span class="texture01"></span>
                    </li>
                    <li>
                        <span class="texture02"></span>
                    </li>
                </ul>
                <div class="hill01"></div>
                <div class="hill02"></div>
                <div class="hill03"></div>
            </div>
            <div class="scroll-more"></div>
        </div>
        <!-- jubao-section01 end -->

        <!-- jubao-section02 start -->
        <div class="jubao-section02">
            <div class="blockW">
                <div class="jubao-se02-area jubao-se02-area01">
                    <div class="main-title main-title18">
                        <h2>什么是聚宝计划</h2>
                    </div>
                    <div class="jubao-describe">
                        <p class="txt-type03">聚宝计划是中青宝旗下的网游投资平台，投资范围覆盖创意、人才、创业团队、成熟企业。早期网游产品、半成品网游、成熟网游精品等网游相关的各个方面。我们的投资内容广泛，投资方式开放，我们希望更多的行业优秀人才和团队能加入我们的队列，让我们一起铸造中国民族网游的超级航母。</p>
                    </div>
                    <ul class="explain-list clearfix">
                        <li>投资支持</li>
                        <li>发行支持</li>
                        <li>云服务支持</li>
                        <li>技术支持</li>
                        <li>运营支持</li>
                    </ul>
                </div>

                <div class="jubao-se02-area jubao-se02-area02">
                    <div class="main-title main-title19">
                        <h2>团队加盟</h2>
                    </div>
                    <div class="jubao-describe">
                        <p class="txt-type03">有着优秀的团队，却缺少足够的资金支持；有着优秀Idea，却缺少足够的推广资源……如果您还在为此烦恼，就请加入我们吧，"聚宝"计划将为您提供资金、场地、指导、推广等全方位的支持！<br>
                            聚宝"计划将以团队的最大需求为团队量身定做合作模式，充足的资金和丰富的资源将是您实现团队梦想的坚实后盾。我们更多的是提供"帮助"，力求与您实现双赢，您的团队将拥有对项目的高度自主权！<br>
                            马上在线填写提交您的团队情况，上传您的团队梦想，好的团队如同好的游戏一样令人期待。</p>
                    </div>
                    <img src="~assets/img/jubao/join_flow01.png" alt="">
                </div>

                <div class="jubao-se02-area jubao-se02-area03">
                    <div class="main-title main-title20">
                        <h2>个人加盟</h2>
                    </div>
                    <div class="jubao-describe">
                        <p class="txt-type03">如果您是一位优秀的网游从业者，有着较完善的项目计划，却因资金、人员、推广等资源而无法实现自己创业梦想，那么请不要犹豫，加入中青宝网"聚宝"计划，我们将给您一个实现梦想的平台。<br>
                            我们致力于打造中国最优秀的民族网游，愿意为优秀的网游人才创造良好的平台。"聚宝"计划将为有志之士提供全方面的资源支持，平等对待，彼此分享！
                            马上在线填写提交您的简历，上传您的梦想，我们给您带来一片展现的天地！</p>
                    </div>
                    <img src="~assets/img/jubao/join_flow02.png" alt="">
                    <span class="cloud-top"></span>
                    <span class="cloud-bom"></span>
                </div>

                <div class="jubao-se02-area jubao-se02-area04">
                    <div class="main-title main-title21">
                        <h2>常见问题</h2>
                    </div>
                    <!-- faq-detail start -->
                    <div class="faq-detail clearfix">
                        <div class="faq-box">
                            <dl>
                                <dt>Q：投资内容包含哪些？</dt>
                                <dd>A：我们的投资内容广泛，覆盖了网游人才、创业团队、成熟企业的创意、网游产品及网游相关产业等各个方面。</dd>
                            </dl>
                        </div>
                        <div class="faq-box">
                            <dl>
                                <dt>Q：投资方式是什么样的？</dt>
                                <dd>A：我们的投资方式开放，兼容性强，您认为合适的投资方式，合作、管理模式都是我们讨论的议题。</dd>
                            </dl>
                        </div>
                        <div class="faq-box">
                            <dl>
                                <dt>Q：什么样的项目才能获得投资？</dt>
                                <dd>A：我们会根据投资经理及投资委员会对项目内容、项目潜力、团队人员、商业前景等综合考量；</dd>
                            </dl>
                        </div>
                        <div class="faq-box">
                            <dl>
                                <dt>Q：如何加盟聚宝计划？</dt>
                                <dd>A：请提供内容详细的资料并通过我们的页面底部聚宝专设邮箱投递，以便我们在最短的时间内作出评估和反馈。</dd>
                            </dl>
                        </div>
                        <div class="faq-box">
                            <dl>
                                <dt>Q：如果没拿到投资，是否就没有其他合作了？</dt>
                                <dd>A：投资只是其中一种合作方式，我们将以团队的最大需求为团队量身定做合作模式；</dd>
                            </dl>
                        </div>
                        <div class="faq-box">
                            <dl>
                                <dt>Q：我可以在哪了解关于聚宝计划的更多信息？</dt>
                                <dd>A：可以通过页面下方的联系邮件或联系电话与我们取得联系后获得更多您想了解的信息；</dd>
                            </dl>
                        </div>
                    </div>
                    <!-- faq-detail end -->
                </div>

            </div>
        </div>
        <!-- jubao-section02 end -->

        <!-- about-contact start -->
        <div class="about-contact jubao-contact">
            <div class="blockW">
                <div class="main-title main-title12">
                    <h2>联系我们</h2>
                </div>
                <div class="about-contact-msg">
                    <div class="jubao-model"></div>
                </div>
            </div>
        </div>
        <!-- about-contact end -->

    </div>
    <!-- content end -->

    <!-- footer start -->
    <!-- footer end -->
</div>
</template>
<script>
export default {
  mounted(){
    function hs01() {
      let wH = $(window).height() -80;
      let hs01H = $(".jubao-section01").height();
      if(hs01H < 1008) {
        $(".jubao-section01").css({
          height: wH + "px",
        });
        $("#mindscape").css({
          height: wH + "px",
        });
      } else {
        $(".jubao-section01").css({
          height: "1080px",
        });
        $("#mindscape").css({
          height: "1080px",
        });
      }
    }
    hs01();
    $(window).resize(function() {
      hs01();
    });
    let screenW = $(window).width();
		let screenH = $(window).height();
		$('#mindscape').smart3d(screenW);
		$('#mindscape li').css({
			width: screenW + "px",
			height: screenH + "px"
		});
  }
}
</script>
<style scoped lang="scss"> 
.jubao-section01 {
  position: relative;
  width: 100%;
  height: 100%;
  max-height: 1080px;
  box-sizing: border-box;
  background: url(~assets/img/jubao/bg.jpg) no-repeat center top;
  background-size: cover;
}
#mindscape {
  position: absolute;
  // top: 0;
  top: -80px;
  left: 0;
  // width: 100%;
  width: 90%;
  // width: 1200px;
  margin: 0 auto;
}
.jubao-title,
.clouding {
  position: absolute;
  width: 35%;
  left: 32.5%;
}
.jubao-title {
  top: 18.1%;
  z-index: 10;
}
.clouding {
  top: 25.6%;
  z-index: 9;
}
.hill01,
.hill02,
.hill03,
.texture01,
.texture02 {
  position: absolute;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.hill01 {
  bottom: 14.81%;
  left: 30.26%;
  width: 12.4%;
  height: 12.13%;
  background-image: url(~assets/img/jubao/hill01.png);
}
.hill02 {
  bottom: 19.07%;
  right: 28.7%;
  width: 13.85%;
  height: 12.13%;
  background-image: url(~assets/img/jubao/hill02.png);
}
.hill03 {
  bottom: 0;
  left: 0;
  width: 100%;
  height: 14.72%;
  background-image: url(~assets/img/jubao/hill03.png);
}
.texture01 {
  top: 80px;
  left: 0;
  width: 36.51%;
  height: 23.24%;
  background-image: url(~assets/img/jubao/texture01.png);
}
.texture02 {
  top: 80px;
  right: 0;
  width: 29.17%;
  height: 19.26%;
  background-image: url(~assets/img/jubao/texture02.png);
}

.jubao-se02-area {
  position: relative;
  padding-bottom: 160px;
  overflow: hidden;
}
.jubao-se02-area01 {
  padding: 160px 0;
  overflow: hidden;
}
.cloud-top,
.cloud-bom {
  position: absolute;
  background-repeat: no-repeat;
}
.cloud-top {
  top: -91px;
  right: 180px;
  width: 227px;
  height: 91px;
  background-image: url(~assets/img/cloud_top.png);
}
.cloud-bom {
  bottom: 13px;
  left: 0;
  width: 319px;
  height: 111px;
  background-image: url(~assets/img/cloud_bom.png);
}
.jubao-describe {
  width: 800px;
  margin: 24px auto 80px;
}
.explain-list {
  position: relative;
}
.explain-list:before {
  content: "";
  position: absolute;
  top: -83px;
  left: 0;
  width: 1200px;
  height: 271px;
  background: url(~assets/img/jubao/line.png) no-repeat;
}
.explain-list li {
  position: relative;
  float: left;
  width: 140px;
  padding-top: 164px;
  margin-right: 125px;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
}
.explain-list li:nth-child(5) {
  margin-right: 0;
}
.explain-list li:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 140px;
  height: 140px;
  background: url(~assets/img/jubao/sprite.png) no-repeat;
}
.explain-list li:nth-child(2):before {
  background-position: -141px 0;
}
.explain-list li:nth-child(3):before {
  background-position: -282px 0;
}
.explain-list li:nth-child(4):before {
  background-position: -423px 0;
}
.explain-list li:nth-child(5):before {
  background-position: -564px 0;
}
.jubao-se02-area04 .faq-detail {
  margin-top: 80px;
}
.jubao-contact {
  background-image: url(~assets/img/jubao/contact_bg.jpg);
}
/*.jubao-contact li {padding: 0 34px;}
.jubao-contact .acTxt {display: inline-block; line-height: 24px; vertical-align: middle;}*/
.jubao-model {
  width: 1200px;
  height: 52px;
  margin: 0 auto;
  background: url(~assets/img/jubao/model.png) no-repeat;
}

.txt-type02 {
  color: #fff;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 1px;
  text-align: justify;
}
.txt-type03 {
  color: rgba(255, 255, 255, 0.6);
  font-size: 14px;
  line-height: 24px;
  letter-spacing: 2px;
  text-align: center;
}
.main-title18 h2 {
  width: 280px;
  background-position: 0 -760px;
}
.main-title19 h2 {
  width: 162px;
  background-position: 0 -800px;
}
.main-title20 h2 {
  width: 162px;
  background-position: 0 -840px;
}
.main-title21 h2 {
  width: 164px;
  background-position: 0 -880px;
}
.main-title22 h2 {
  width: 510px;
  background-position: 0 -920px;
}
.imgsize {
  width: 100%;
  height: 100%;
}
.main-title12 h2 {
  width: 158px;
  background-position: 0 -440px;
}
.jubao-section02{
  background-color: #202e40;
}
.faq-detail {
  margin-right: -20px;
}
.faq-detail h2 {
  margin-bottom: 48px;
}
.faq-detail .faq-box {
  float: left;
  width: 590px;
  margin: 0 20px 20px 0;
  border-radius: 6px;
  background: linear-gradient(to top, #708cb2, #475a72);
  background: -ms-linear-gradient(to top, #708cb2, #475a72);
  background: -webkit-linear-gradient(to top, #708cb2, #475a72);
  background: -moz-linear-gradient(to top, to top, #708cb2, #475a72);
}
.faq-detail .faq-box dl {
  width: 540px;
  padding: 24px;
  margin: 1px;
  line-height: 24px;
  letter-spacing: 1px;
  border-radius: 6px;
  background: #202e40;
}
.faq-detail .faq-box dt {
  font-size: 14px;
  font-weight: bold;
}
.faq-detail .faq-box dd {
  color: #b7b7b7;
  font-size: 14px;
}
.about-contact .blockW{
  padding: 115px 0;
}
.about-contact-msg {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 70px;}
</style>